import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

export interface State {
  favicon: 'default' | 'in-progress' | 'error' | 'success'
}

export interface Actions {
  setFavicon: (favicon: State['favicon']) => void
}

export const useStore = create<State & Actions>()(
  devtools((set, _get) => ({
    favicon: 'default',
    setFavicon: (favicon: State['favicon']) => {
      set({ favicon })
    },
  })),
)
